import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MasterService } from '../../../Services/master.service';
import { CookieService } from 'ngx-cookie-service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { SearchProductparam } from 'src/app/Models/search-product';
import { ProductSearchParam } from '../../../Models/product';


@Component({
  selector: 'app-product-search',
  templateUrl: './product-search.component.html',
  styleUrls: ['./product-search.component.css']
})
export class ProductSearchComponent implements OnInit {
  
  //private product: SearchProduct
  public ProductCategoryList: any[] = [];
  public ProductGroupList: any[] = [];
  public ProductCodes: any[] = [];
  public Products: any[] = [];
  public prodSegmentId :number=0;
  public productGroupId :number=-1;
  public selected:any;
  ProductSearchParam :ProductSearchParam;
  //public selected:[]=[];
  

   public FormModel: SearchProductparam;
  @Output("searchProduct") searchProduct: EventEmitter<SearchProductparam> = new EventEmitter();
  constructor(private _MasterService: MasterService
    , public cookieService: CookieService
    , private intl: MatPaginatorIntl
    , private changeDectector: ChangeDetectorRef
  ) {
    this.ProductSearchParam = new ProductSearchParam();
    this.FormModel = new SearchProductparam();
  }

  ngOnInit(): void {
    this._MasterService.GetAllProductCategory().subscribe((d) => {
      
       // this.ProductCategoryList.push({ "prodSegmentId": "-1", "prodSegmentDesc": "--All--" });
        this.ProductCategoryList = this.ProductCategoryList.concat(d);
    
    });

    this._MasterService.GetAllProductGroup().subscribe((d) => {
      
      //this.ProductGroupList.push({ "productGroupId": "-1", "productGroupDesc": "--All--" });
      this.ProductGroupList = this.ProductGroupList.concat(d);
  
  });
    
  }

  OnCategoryChange(prodSegmentId?:number){
    this.selected={};
    this.ProductCodes=[];
    let product: any = this.ProductCategoryList.filter(p =>
      p.prodSegmentId == prodSegmentId
    )[0];
    this.prodSegmentId = parseInt(product.prodSegmentId);
    this.FormModel.ProdSegmentId=this.prodSegmentId;
  }

  
  OnGroupChange(productGroupId?:number){
    this.selected={};
    this.ProductCodes=[];
    if(productGroupId==0){
      
      this.productGroupId=-1;
    }
    else{
      let product: any = this.ProductGroupList.filter(p =>
        p.productGroupId == productGroupId
      )[0];
      this.productGroupId = parseInt(product.productGroupId);
      this.FormModel.ProductGroupId= this.productGroupId;
     
    }
   
  
  }
  
  onProductCodeKeypress(event: any) {
    this.ProductCodes = [];
    if (event.target.value.length > 2) {
      this.ProductSearchParam.ProdSegmentId = parseInt(this.FormModel.ProdSegmentId.toString());
      this.ProductSearchParam.ProductCode=event.target.value;
      this.ProductSearchParam.ProductGroupId=this.FormModel.ProductGroupId;
      
      this._MasterService.GetAllProductCode(this.ProductSearchParam).subscribe((d) => {
        this.ProductCodes = this.ProductCodes.concat(d);
      });
    }
  }

formSubmit() {
  if(this.FormModel.ProdSegmentId==0){
    alert('please select Product category!');
    return;
  }
  this.FormModel.ProductCode=this.selected.productCode;
  if(this.FormModel.ProductGroupId==0){
    this.FormModel.ProductGroupId=-1;
  }

  this.searchProduct.emit(this.FormModel);
  if(this.FormModel.ProductGroupId==-1){
    this.FormModel.ProductGroupId=0;
  }
}

}
